export const MAX_OFFLINE_PROPERTIES: number = 4;

export enum DataStoreSyncResult {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE"
}